import React, { useState, useEffect } from "react";

import useStyles from "./style";

import { auth } from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import InputBase from "@material-ui/core/InputBase";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import Gap from "../../atoms/Gap";
import WithTitleCart from "./WithTitleCart";
import WithSearchCart from "./WithSearchCart";
import WithSearchBack from "./withSearchBack";
import WithTitle from "./WithTitle";
import ForTokosaya from "./ForTokosaya";
import { useHistory } from "react-router-dom";
import Badge from "@material-ui/core/Badge";
import WithTitleSale from "./WithTitleSale";
import ProdukDetail from "./produkDetail";

function Header({
  placeholder,
  value,
  type,
  title,
  onClick,
  onChange,
  // onFocus,
  // autoFocus,
  onBack,
  onClickTitle,
  tipeOnClickTitle,
}) {
  const classes = useStyles();
  const history = useHistory();
  const [changeColor, setChangeColor] = useState(false);
  const [hideNotif, setHideNotif] = useState(false);
  const [totalCart, setTotalCart] = useState(0);
  const { cart } = useData();
  const onFocus = () => {
    history.push("/browse");
  };

  const subcarts = Object.entries(cart?.subcarts ?? {}).sort((a, b) => {
    return a.created_at?.toMillis?.() - b.created_at?.toMillis?.();
  });

  let angka = 0;
  useEffect(() => {
    subcarts.map(([subcarts, products]) => {
      angka = products?.products
        ? angka + Object.values(products?.products).length
        : 0;
    });
    // console.log('ini dia', angka);
    setTotalCart(angka);
  }, [subcarts]);

  useEffect(() => {
    const changeNavbar = () => {
      if (window.scrollY >= 400) {
        setChangeColor(true);
      } else {
        setChangeColor(false);
      }
    };

    window.addEventListener("scroll", changeNavbar);

    return () => {
      window.removeEventListener("scroll", changeNavbar);
    };
  }, []);

  useEffect(() => {
    const topNavbar = () => {
      if (window.scrollY >= 50) {
        setHideNotif(true);
      } else {
        setHideNotif(false);
      }
    };

    window.addEventListener("scroll", topNavbar);

    return () => {
      window.removeEventListener("scroll", topNavbar);
    };
  }, []);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = useState(false);

  const logout = () => {
    auth.signOut();
  };

  if (type === "with-title-cart") {
    return (
      <WithTitleCart title={title} onClick={onClick} totalCart={totalCart} />
    );
  }
  if (type === "with-search-cart") {
    return (
      <WithSearchCart title={title} onClick={onClick} totalCart={totalCart} />
    );
  }
  if (type === "produk-detail") {
    return (
      <ProdukDetail title={title} onClick={onClick} totalCart={totalCart} />
    );
  }
  if (type === "with-title") {
    return (
      <WithTitle
        title={title}
        onClick={onClick}
        back={true}
        onClickTitle={onClickTitle}
        tipeOnClickTitle={tipeOnClickTitle}
      />
    );
  }
  if (type === "with-title-sale") {
    return (
      <WithTitleSale
        title={title}
        onClick={onClick}
        back={true}
        onClickTitle={onClickTitle}
        tipeOnClickTitle={tipeOnClickTitle}
      />
    );
  }
  if (type === "for-tokosaya") {
    return (
      <ForTokosaya title={title} onClick={onClick} totalCart={totalCart} />
    );
  }
  if (type === "with-back") {
    return (
      <WithSearchBack
        placeholder={placeholder}
        onChange={onChange}
        onClick={onClick}
        value={value}
        totalCart={totalCart}
        onBack={onBack}
      />
    );
  }

  return (
    <div
      className={classes.root}
      style={
        changeColor
          ? {
              top: 0,
              backgroundColor: "white",
              boxShadow: "0px 15px 10px -15px rgba(0,0,0,0.3)",
              zIndex: "999",
            }
          : hideNotif
          ? { top: 0, transition: "all .2s ease-out", zIndex: "999" }
          : { top: 40, zIndex: "999" }
      }
    >
      <div
        className={classes.searchBox}
        style={
          !changeColor
            ? {
                boxShadow: "0px 15px 10px -15px rgba(0,0,0,0.3)",
              }
            : null
        }
      >
        <SearchIcon className={classes.icSearch} />
        <Gap width={10} />
        <InputBase
          onFocus={onFocus}
          inputProps={{ "aria-label": "search" }}
          fullWidth
        />
      </div>
      <Gap width={16} />
      <IconButton onClick={() => history.push("/cart")} size="small">
        <Badge badgeContent={totalCart} color="secondary">
          <ShoppingCartIcon className={classes.icCart} />
        </Badge>
      </IconButton>
    </div>
  );
}

export default Header;
